import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { contacts } from '../../../../modules/customer/profile';
import { push } from 'connected-react-router';
import { customer, ui } from '../../../../modules';

const ContactBox = ({ rows, selectContact, goToDetails, id }) => {   
    const clickHandler = (i) => {
        selectContact(i);
        goToDetails(id);
    }
    return <div>
        <table className="table box-table-striped contact-list">
            <thead>
                <tr>
                    <th className="col-xs-2"><b>Dato:</b> </th>
                    <th className="col-xs-10"><b>Detaljer:</b> </th>
                </tr>
            </thead>
            <tbody>
                {rows.map((row, i) => <tr key={i} onClick={() => clickHandler(i) } className="contact-preview-item">
                    <td>{row.createdAt}</td>
                    <td className="cutLongText">{row.comment || row.actionTaken}</td>
                </tr>
                )}
            </tbody>
        </table>
    </div>;
}

const mapStateToProps = (state, props) => ({
    id: customer.profile.selectors.getCustomerID(state)
});

const mapDispatchToProps = (dispatch, props) => ({
    selectContact: (id) => dispatch(contacts.actions.selectContact(id)),
    goToDetails: (id) => dispatch(push(ui.selectors.getUrlForCustomer(id, 'contacts', false)))
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactBox);